import { render, staticRenderFns } from "./ActivitiesContent.vue?vue&type=template&id=7217cbeb&"
import script from "./ActivitiesContent.vue?vue&type=script&lang=js&"
export * from "./ActivitiesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7217cbeb')) {
      api.createRecord('7217cbeb', component.options)
    } else {
      api.reload('7217cbeb', component.options)
    }
    module.hot.accept("./ActivitiesContent.vue?vue&type=template&id=7217cbeb&", function () {
      api.rerender('7217cbeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/activities/ActivitiesContent.vue"
export default component.exports